import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { I18N, GlobalContext } from 'commons';
import { SUPPORTED_LOCALES } from 'utils';
import { translationType } from 'constants/applicationConstant';
import CustomDropdown from './CustomDropdown';

const Language = () => {

  const { lang, changeLang, organization: { translation } } = useContext(GlobalContext);
  const [selectedLang, setSelectedLang] = useState(lang);

  useEffect(() => {
    if (translation.type === translationType.GOOGLE) {
      const scriptElement = document.createElement('script');
      scriptElement.id = 'translate-script';

      const googleTranslate = {
        key: translation.key,
        metaTag: document.createElement('meta'),
        injectScript: scriptElement,
        url: `//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&hl=${lang}`,
      };

      if (!document.getElementById('google_translate_element_selector')) {
        googleTranslate.metaTag.name = 'google-translate-customization';
        googleTranslate.metaTag.content = translation.key;
        document.getElementsByTagName('head')[0].appendChild(googleTranslate.metaTag);

        googleTranslate.injectScript.type = 'text/javascript';
        googleTranslate.injectScript.src = googleTranslate.url;
        document.getElementsByTagName('head')[0].appendChild(googleTranslate.injectScript);

        window.googleTranslateElementInit = () => {
          googleTranslate.translate = new google.translate.TranslateElement(
            {
              pageLanguage: lang,
              autoDisplay: false,
              floatPosition: 0,
              multilanguagePage: true,
            },
            'google_translate_element',
          );

          const googleTranslateSelect = document.querySelector('#google_translate_element select');
          googleTranslateSelect && googleTranslateSelect.setAttribute('id', 'google_translate_element_selector');

          const googleTranslateHideText = document.getElementById('goog-gt-tt');
          googleTranslateHideText && googleTranslateHideText.remove();

          const googleTranslateSpinner = document.querySelector('div.goog-te-spinner-pos');
          googleTranslateSpinner && googleTranslateSpinner.remove();
        };
      }
    }
  }, [translation.type])

  const handleSelectChange = (selectedLang) => {
    setSelectedLang(selectedLang);
    changeLang(selectedLang);
  };

  const getTranslationType = () => {
    if (translation.type === translationType.EVERBRIDGE) {
      return (
        <CustomDropdown
          options={SUPPORTED_LOCALES}
          value={selectedLang}
          onChange={handleSelectChange}
        />
      );
    } else if (translation.type === translationType.GOOGLE) {
      return <div className="google-translate-element" id="google_translate_element" />;
    }
    return "";
  }

  const isRightAligned = lang !== 'ar_SA' && translation.type === translationType.EVERBRIDGE;

  return (
    <div className={`translate-container clearfix  ${isRightAligned ? 'right-aligned' : 'left-aligned'}`}>
      <label className="col-form-label font-weight-bold pt-2 pr-2" htmlFor="google_translate_element_selector" id="langLabel">
        <i className="fas fa-globe" style={{ marginRight: '8px' }}></i>
        <I18N>global.translation.languages.label</I18N>
      </label>
      {getTranslationType()}
    </div>
  )
};

export default Language;